import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: {
      backgroundColor: scssVariables.ColorFog20,
      color: scssVariables.ColorFog100,
    },
  },
  variants: [
    {
      props: { size: 'tiny' },
      style: {
        width: 'var(--input-height-tiny)',
        height: 'var(--input-height-tiny)',
        font: 'var(--font-label)',
      },
    },
    {
      props: { size: 'small' },
      style: {
        width: 'var(--input-height-small)',
        height: 'var(--input-height-small)',
        font: 'var(--font-h3)',
      },
    },
    {
      props: { size: 'medium' },
      style: {
        width: 'var(--input-height-medium)',
        height: 'var(--input-height-medium)',
        font: 'var(--font-h2)',
      },
    },
    {
      props: { size: 'large' },
      style: {
        width: 'var(--input-height-large)',
        height: 'var(--input-height-large)',
        font: 'var(--font-h1)',
      },
    },
  ],
};
